(function() {
	'use strict';

	/**
	 * @ngdoc service
	 * @name print.service:PrintService
	 * 
	 * @description
	 * 
	 */
	angular.module('print').service('PrintService', PrintService);

	function PrintService(RemoteService, MessageService, PrintRequestFactory) {
		var self = this;

		self.rowCount = 8;// default row count

		self.getGDData = function(params, successFn) {
			var crewTypeList = (!!params.crewTypes) ? params.crewTypes.split(',') : [];
			var reParams = PrintRequestFactory.getPrintGDRQ(params.blockId, crewTypeList, params.crewScheduleEventId);
			RemoteService.loadGD(reParams).then(function(response) {
				successFn(formatGDDataForDisplay(response));
			}, function(error) {
				MessageService.error(error);
			});
		};

		function formatGDDataForDisplay(gdResponse) {
			if (!!gdResponse
					&& gdResponse.hasOwnProperty('joiningCrewCollection')
					&& gdResponse.hasOwnProperty('journeyDetails')) {
				var gdArray = [], gdDisObj = [], crewList = [];
				// set row count
				if (!!gdResponse.joiningCrewCollection
						&& gdResponse.joiningCrewCollection.length > 0
						&& self.rowCount < gdResponse.joiningCrewCollection.length) {
					self.rowCount = gdResponse.joiningCrewCollection.length;
				}

				// set crewList to display
				for (var i = 0; i < self.rowCount; i++) {
					var crew = PrintRequestFactory.getGDCrew();
					if (!angular
							.isUndefined(gdResponse.joiningCrewCollection[i])) {
						crew = gdResponse.joiningCrewCollection[i];
					}
					crewList.push(crew);
				}

				// set gd display
				angular.forEach(gdResponse.journeyDetails, function(journey) {
					var gdDisplay = PrintRequestFactory.getGDDisplayModel();
					// set journey details
					gdDisplay.acModels = journey.aircraftModel;
					gdDisplay.dates = journey.estDipatureDate;
					gdDisplay.flightNumbers = journey.flightNO;
					gdDisplay.registrationNos = journey.regNo;
					gdDisplay.onds.push(journey.route);
					gdDisplay.departureFrom = journey.origin;
					gdDisplay.arrivalAt = journey.destination;
					gdDisplay.operator = 'Kuwait Airways';
					gdDisplay.route = journey.route;
					// set crew details
					gdDisplay.staffs = angular.copy(crewList);
					gdDisplay.noOfRows = self.rowCount;
					gdArray.push(gdDisplay);
				});

				var acModels = [];
				var dates = [];
				var flightNumbers = [];
				var registrationNos = [];
				var onds = [];
				if (!gdResponse.separateGds && gdArray.length > 1) {
					var gdDisplay = PrintRequestFactory.getGDDisplayModel();
					angular
							.forEach(
									gdArray,
									function(journey) {
										if (journey.acModels!=null && acModels
												.indexOf(journey.acModels) == -1 ) {
											acModels
													.push(journey.acModels);
											gdDisplay.acModels = gdDisplay.acModels != null ? gdDisplay.acModels
													+ "/"
													+ journey.acModels
													: journey.acModels;
										}
										if (journey.dates!=null && dates.indexOf(journey.dates) == -1 ) {
											dates.push(journey.dates);
											gdDisplay.dates = gdDisplay.dates !== null ? gdDisplay.dates
													+ "/" + journey.dates
													: journey.dates;
										}
										if (journey.flightNumbers!=null && flightNumbers
												.indexOf(journey.flightNumbers) == -1) {
											flightNumbers
													.push(journey.flightNumbers);
											gdDisplay.flightNumbers = gdDisplay.flightNumbers !== null ? gdDisplay.flightNumbers
													+ "/"
													+ journey.flightNumbers
													: journey.flightNumbers;
										}
										if (journey.registrationNos!=null && registrationNos
												.indexOf(journey.registrationNos) == -1) {
											registrationNos
													.push(journey.registrationNos);
											gdDisplay.registrationNos = gdDisplay.registrationNos !== null ? gdDisplay.registrationNos
													+ "/"
													+ journey.registrationNos
													: journey.registrationNos;
										}
										if (gdDisplay.departureFrom == null
												&& journey.departureFrom != null) {
											gdDisplay.departureFrom = journey.departureFrom;
										}
										if (journey.arrivalAt != null ) {
											gdDisplay.arrivalAt = journey.arrivalAt;
										}
										if (journey.route != null
												&& onds.indexOf(journey.route) == -1) {
											onds.push(journey.route); 
										}
									});
					gdDisplay.staffs = crewList;
					gdDisplay.onds = onds;
					gdDisplay.operator = 'Kuwait Airways';
					gdDisObj.push(gdDisplay);
				} else {
					gdDisObj = gdArray;
				}
			}
			return gdDisObj;
		}

		function adaptResponce(response) {
			if (response.joiningCrewCollection.length < 7) {
				for (var i = 0; i < 7 - response.joiningCrewCollection.length; i++) {
					var newList = PrintRequestFactory.getCrewDataList();
					response.joiningCrewCollection.push(newList);
				}

			}
			var regNumbers = [];
			var regNosStr = '';
			if(!!response.journeyDetails){
				for(var i=0; i<response.journeyDetails.length; i++ ){
					if(!!response.journeyDetails[0].regNo  && regNumbers
							.indexOf(response.journeyDetails[i].regNo) === -1){						
						regNosStr += (regNosStr == '') ? response.journeyDetails[i].regNo : "/"+response.journeyDetails[i].regNo ;
						regNumbers.push(response.journeyDetails[i].regNo);
					}
				}
				response.journeyDetails[0].regNo = regNosStr;
			}
			return response;
		}

		self.getJourneyLogData = function(params, successFn) {
			var searchParams = PrintRequestFactory.getPrintJourneyRQ(params);
			RemoteService.getJourneyLogData(searchParams).then(
					function(response) {
						successFn(adaptResponce(response));
					}, function(error) {
						MessageService.error(error);
					});
		};

	}
})();